import React from 'react';
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import RetinaImage from "react-retina-image";

const SalesMenu = ({ collections, menu_item }) => {
    return (
        <div className="top-nav">
            <Container>
                <Row>
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 3, offset: 0 }} >
                        <h4 className="top-nav__nav-title">Clearance</h4>
                        <Nav className="top-nav__nav-list">
                            {collections.map((collection) => {
                                return (
                                    <Nav.Item
                                        key={collection.title}
                                        className="top-nav__nav-list-item-primary nav-link nav-top-link"
                                        as="a"
                                        href={collection.url}
                                    >
                                        {collection.title}
                                    </Nav.Item>
                                )
                            })}
                        </Nav>
                    </Col>
                    <Col lg={6}>
                        <a
                            href={menu_item.img_url}
                            className="top-nav__promo-image-link"
                        >
                            {menu_item && menu_item.img &&
                                <RetinaImage
                                    alt={`All ${menu_item.title}`}
                                    title={`All ${menu_item.title}`}
                                    className="top-nav__promo-image"
                                    src={menu_item.img}
                                />
                            }
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default SalesMenu;